module.exports = __webpack_public_path__ + "static/media/no_ads_dec_2021_thumb.795745f6.jpg";